























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SkalaNyeri from "@/components/pemeriksaan/assesmen/SkalaNyeri.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";

@Component({
  components: {
    SkalaNyeri,
    Lokasi,
    Durasi,
    Frekuensi,
    Pencetus,
    KualitasNyeri,
    PolaSerangan,
    PenyebabNyeriHilang,
    JenisNyeri,
  },
})
export default class Nyeri extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop() nyeri!: object;
  hideSkala = false;

  setSkalaNyeri(val) {
    if (val > 0) {
      this.hideSkala = true;
      if (this.nyeri["jenis"] == "0") {
        this.nyeri["jenis"] = "1";
      }
    } else {
      this.hideSkala = false;
    }
    this.nyeri["skala"] = val;
  }
  setLokasi(val) {
    this.nyeri["lokasi"] = val;
  }
  setDurasi(val) {
    this.nyeri["durasi"] = val;
  }
  setFrekuensi(val) {
    this.nyeri["frekuensi"] = val;
  }
  setPencetus(val) {
    this.nyeri["pencetus"] = val;
  }
  setKualitasNyeri(val) {
    this.nyeri["kualitas"] = val;
  }
  setPolaSerangan(val) {
    this.nyeri["pola_serangan"] = val;
  }
  setPenyebabNyeriHilang(val) {
    this.nyeri["penyebab_hilang"] = val;
  }
  setJenisNyeri(val) {
    this.nyeri["jenis"] = val;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  mounted() {}

  @Watch("nyeri")
  changeNyeri(val) {
    if (val["skala"] > 0) {
      this.hideSkala = true;
      // console.log(">0");
    } else {
      // console.log("=0");
      this.hideSkala = false;
    }
    this.$emit("nyeri", this.nyeri);
  }
}
